/**
 * Default credit cost per error source. Used as the pre-filled refund amount in the
 * unified errors view. Admin can override per-refund in the confirm dialog.
 *
 * These values mirror the `baseline_*` fields in `system_pricing_config` but are
 * kept simple integers here since refunds are issued in whole credits.
 */
export type ErrorSource =
  | "content_filter"
  | "graph"
  | "extraction"
  | "smart_note"
  | "report";

export const ERROR_COSTS: Record<ErrorSource, number> = {
  content_filter: 1,
  graph: 1,
  extraction: 1,
  smart_note: 2,
  report: 1,
};

export const REFUND_BONUS = 5;

export function getRefundAmount(source: ErrorSource, override?: number): number {
  const cost = override ?? ERROR_COSTS[source] ?? 1;
  return Math.max(1, Math.round(cost)) + REFUND_BONUS;
}

export const SOURCE_LABELS: Record<ErrorSource, string> = {
  content_filter: "Content Filter",
  graph: "Graph API",
  extraction: "Extraction Failed",
  smart_note: "Smart Note Failed",
  report: "User Report",
};

export const SOURCE_BADGE_VARIANTS: Record<
  ErrorSource,
  "destructive" | "default" | "secondary" | "outline"
> = {
  content_filter: "destructive",
  graph: "default",
  report: "secondary",
  extraction: "outline",
  smart_note: "outline",
};
